import React, { useState } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import ModalHoc from '../Hoc/modalHoc';
import { axiosApi } from '../Basicos/axiosInstances';

const estiloSecao = {
    color: '#000',
    fontWeight: 700,
    fontSize: '0.95rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: '1rem',
    paddingBottom: '0.5rem',
    borderBottom: '1px solid #e9ecef',
};

const estiloLabel = {
    fontWeight: 600,
    fontSize: '0.8rem',
    color: '#495057',
};

function ModalCampanhaVacinacao(props) {
    const { estrutura } = props;
    const { titulo, requisicaoURL, metodoRequisicao } = estrutura.modal;

    const [periodoLetivoId, setPeriodoLetivoId] = useState(estrutura.model?.periodo_letivo_id ?? '');
    const [dataInicio, setDataInicio] = useState(estrutura.model?.data_inicio?.slice(0, 10) || '');
    const [dataFim, setDataFim] = useState(estrutura.model?.data_fim?.slice(0, 10) || '');
    const [vacinas, setVacinas] = useState(estrutura.vacinas || []);
    const [salvando, setSalvando] = useState(false);

    const atualizarVacina = (index, campo, valor) => {
        setVacinas((atual) => atual.map((vacina, i) => (i === index ? { ...vacina, [campo]: valor } : vacina)));
    };

    const tipoDeAcao = metodoRequisicao === 'put' ? 'editar' : 'adicionar';

    const salvar = async () => {
        setSalvando(true);

        try {
            const response = await axiosApi({
                method: metodoRequisicao,
                url: requisicaoURL,
                data: {
                    periodo_letivo_id: periodoLetivoId,
                    intervalo_data: { from: dataInicio, to: dataFim },
                    vacinas: vacinas.map((vacina) => ({
                        ...vacina,
                        doses_necessarias: vacina.doses_necessarias === '' ? null : vacina.doses_necessarias,
                        validade_anos: vacina.validade_anos === '' ? null : vacina.validade_anos,
                    })),
                },
            });

            props.ativar(tipoDeAcao, 'sucesso');
            if (props[tipoDeAcao]) props[tipoDeAcao](response.data.model);
            props.toggle();
        } catch (error) {
            if (error.response && error.response.data.erro) {
                props.ativar(error.response.status, error.response.data.erro);
            } else {
                props.ativar(tipoDeAcao, 'erro');
            }
        } finally {
            setSalvando(false);
        }
    };

    return (
        <>
            <Row noGutters style={{ borderBottom: '1px solid #e9ecef' }}>
                <Col sm={12} className="align-content-middle mb-2 mt-2 pb-2">
                    <h4><b>{titulo}</b></h4>
                </Col>
            </Row>
            <Form className="text-secondary p-4">
                <div style={estiloSecao}>Período de envio</div>
                <Row form className="align-items-end">
                    <Col md={4}>
                        <FormGroup>
                            <Label style={estiloLabel}>Período Letivo</Label>
                            <Input type="select" value={periodoLetivoId} onChange={(e) => setPeriodoLetivoId(e.target.value)} required>
                                <option value="">Selecione...</option>
                                {(estrutura.periodos_letivos || []).map((periodo) => (
                                    <option key={periodo.value} value={periodo.value}>{periodo.label}</option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label style={estiloLabel}>Data Início</Label>
                            <Input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} required />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label style={estiloLabel}>Data Fim</Label>
                            <Input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} required />
                        </FormGroup>
                    </Col>
                </Row>

                <div style={{ ...estiloSecao, marginTop: '1.5rem' }}>Vacinas exigidas</div>
                <p className="text-muted" style={{ marginTop: '-0.5rem' }}>Marque as vacinas exigidas e defina as doses. Deixe a validade em branco quando a vacina não expira.</p>
                <Table size="sm" bordered className="align-middle">
                    <thead>
                        <tr style={{ backgroundColor: '#f8f9fa' }}>
                            <th style={{ width: 40, textAlign: 'center' }}></th>
                            <th>Vacina</th>
                            <th style={{ width: 160 }}>Doses exigidas</th>
                            <th style={{ width: 160 }}>Validade (anos)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {vacinas.map((vacina, index) => (
                            <tr key={vacina.nome}>
                                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                    <input
                                        type="checkbox"
                                        style={{ width: 16, height: 16, margin: 0 }}
                                        checked={vacina.ativo}
                                        onChange={(e) => atualizarVacina(index, 'ativo', e.target.checked)}
                                    />
                                </td>
                                <td style={{ verticalAlign: 'middle', fontWeight: 600, color: '#333' }}>{vacina.nome}</td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <Input
                                        type="number"
                                        min="1"
                                        bsSize="sm"
                                        disabled={!vacina.ativo}
                                        value={vacina.doses_necessarias ?? ''}
                                        onChange={(e) => atualizarVacina(index, 'doses_necessarias', e.target.value)}
                                    />
                                </td>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <Input
                                        type="number"
                                        min="1"
                                        bsSize="sm"
                                        placeholder="Sem validade"
                                        disabled={!vacina.ativo}
                                        value={vacina.validade_anos ?? ''}
                                        onChange={(e) => atualizarVacina(index, 'validade_anos', e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Form>
            <Col sm={12} className="align-content-middle mb-3 p-0">
                <Button onClick={props.toggle} className="float-right btn-transparente">Cancelar</Button>
                <Button onClick={salvar} disabled={salvando} className="float-right">Salvar</Button>
            </Col>
        </>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
        desativar: () => dispatch(actionsRedux.desativarAlert()),
    };
};

export default connect(null, mapDispatchToProps)(ModalHoc(ModalCampanhaVacinacao));
